import { render, staticRenderFns } from "./W9Form.vue?vue&type=template&id=68ff62f1"
import script from "./W9Form.vue?vue&type=script&lang=js"
export * from "./W9Form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports